import { clearOtpVerified, clearStoredAuthTokens, getStoredRefreshToken, setStoredAccessToken } from 'pages/Auth/utils';
import client from './client';
import { authEndpoints } from './endpoints';
import { IRefreshAccessTokenResponse } from './types';

export const refreshAccessToken = async (): Promise<IRefreshAccessTokenResponse | null> => {
  const refresh = getStoredRefreshToken();

  if (!refresh) {
    clearOtpVerified();
    clearStoredAuthTokens();
    return null;
  }

  try {
    const response = await client.post(authEndpoints.refreshAccessToken, { refresh });
    const newAccessToken = response.data;

    if (!newAccessToken?.access) {
      clearOtpVerified();
      clearStoredAuthTokens();
      return null;
    }

    setStoredAccessToken(newAccessToken.access);

    return newAccessToken;
  } catch {
    clearOtpVerified();
    clearStoredAuthTokens();
  }

  return null;
};

export const memoizedRefreshToken = refreshAccessToken;
